/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { LayoutConfirmModalComponent } from '@layout/confirm-modal/confirm-modal.component';
import { DatalistAnagrafica, PianoInterventi, Progetto } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { ProgettoService } from '@shared/services/progetto.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneOperaModalPianoInterventiComponent } from '../modal-piano-interventi/modal-piano-interventi.component';

@Component({
    selector: 'app-toolkit-opera-tab-piano-interventi',
    templateUrl: './tab-piano-interventi.component.html',
})
export class ToolkitGestioneOperaTabPianoInterventiComponent implements OnInit {

    @Input() canEdit: boolean;
    @Input() formGroup: FormGroup;
    @Input() items: PianoInterventi[] = [];
    @Input() datalist: DatalistAnagrafica;

    constructor(
        private modalService: NgbModal,
        private operaService: OperaService,
        private utilsService: UtilsService,
        private progettoService: ProgettoService
    ) { }

    ngOnInit() {
        this.operaService.pianoInterventiByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: PianoInterventi[]) => {
            this.items = list;
        });
        if(this.items.length > 0 && (this.operaService.operaSession.idOperaOrig === null || this.operaService.operaSession.idOperaOrig === undefined) ) {
            this.progettoService.read(this.items[0].idProgetto).subscribe((prog: Progetto) => { 
                this.formGroup.get('provenienza')?.setValue(prog.denominazione);
            });
        }
    }

    public viewItem(pianoInterventi: PianoInterventi) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalPianoInterventiComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Visualizza';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.formGroup = this.formGroup;
        modal.componentInstance.params = pianoInterventi;
        modal.componentInstance.canEdit = false;
        this.progettoService.read(pianoInterventi.idProgetto).subscribe((prog: Progetto) => {
            modal.componentInstance.currentProgetto = prog;
        });
    }

    public addItem() {
        const modal = this.modalService.open(ToolkitGestioneOperaModalPianoInterventiComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.formGroup = this.formGroup;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.operaService.insertPianoInterventi(result.getRawValue()).subscribe(response => {
                    this.operaService.pianoInterventiByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: PianoInterventi[]) => {
                        this.items = list;
                            this.progettoService.read(this.items[0].idProgetto).subscribe((prog: Progetto) => { 
                                if(this.operaService.operaSession.idOperaOrig === null || this.operaService.operaSession.idOperaOrig === undefined) {
                                    this.formGroup.get('provenienza')?.setValue(prog.denominazione);
                                }
                                this.operaService.update(this.formGroup.getRawValue()).subscribe(()=>{
                                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                            });
                        });
                    });
                });
            }
        }).catch(e => {});
    }

    public editItem(pianoInterventi: PianoInterventi) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalPianoInterventiComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Modifica';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.params = pianoInterventi;
        modal.componentInstance.canEdit = true;
        this.progettoService.read(pianoInterventi.idProgetto).subscribe((prog: Progetto) => {
            modal.componentInstance.currentProgetto = prog;
        });
        modal.result.then(result => {
            if (result) {
                this.operaService.updatePianoInterventi(result.getRawValue()).subscribe(response => {
                    this.operaService.pianoInterventiByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: PianoInterventi[]) => {
                        this.items = list;
                            this.progettoService.read(this.items[0].idProgetto).subscribe((prog: Progetto) => { 
                                if(this.operaService.operaSession.idOperaOrig === null || this.operaService.operaSession.idOperaOrig === undefined) {
                                    this.formGroup.get('provenienza')?.setValue(prog.denominazione);
                                }
                                this.operaService.update(this.formGroup.getRawValue()).subscribe(()=>{
                                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                            });
                        });
                });
            });
        }
        }).catch(e => {});
    }

    public deleteItem(idPianoIntervento: number) {
        const modal = this.modalService.open(LayoutConfirmModalComponent,{size: 'xs'});
        modal.componentInstance.description = 'il Piano intervento e le associazioni ad esso verranno eliminate, si vuole procedere comunque?'
        modal.componentInstance.confirm = () => { 
            this.operaService.deletePianoInterventi(idPianoIntervento).subscribe(response => {
                if (this.utilsService.genericResponse204NoContent(response)) {
                    this.operaService.pianoInterventiByIdOpera(this.operaService.operaSession.idOpera).subscribe(async (list: PianoInterventi[]) => {
                        this.items = list;
                        if(this.operaService.operaSession.idOperaOrig === null || this.operaService.operaSession.idOperaOrig === undefined) {
                            if(this.items.length === 0) {
                                this.formGroup.get('provenienza')?.setValue(null);
                            } else if(this.items.length > 0) {
                                const firstProg = await this.progettoService.read(this.items[0].idProgetto).toPromise();
                                this.formGroup.get('provenienza')?.setValue(firstProg?.denominazione);
                            }
                        }
                        this.operaService.update(this.formGroup.getRawValue()).subscribe(() => {});
                    });
                }
            });
        };

    }

}
